import React from 'react';
import { useSelector } from 'react-redux';

export default function key() {
  const featureDose = useSelector((state) => state.data.mapType);

  const singleBlocksStyle = {
    position: 'relative',
    display: featureDose === 1 ? 'flex' : 'none',
  };

  const doubleBlocksStyle = {
    position: 'relative',
    display: featureDose === 2 ? 'flex' : 'none',
  };

  const boosterBlocksStyle = {
    position: 'relative',
    display: featureDose === 3 ? 'flex' : 'none',
  };

  return (
    <div className="block-key-wrap">
      <div className="block-percent">
        PERCENTAGE OF TOTAL POPULATION VACCINATED
      </div>
      <div className="block-list">
        <div className="block-num" />
        <div className="block-num">0</div>
        <div className="block-num">&nbsp;</div>
        <div className="block-num">20</div>
        <div className="block-num">&nbsp;</div>
        <div className="block-num">40</div>
        <div className="block-num">&nbsp;</div>
        <div className="block-num">60</div>
        <div className="block-num">&nbsp;</div>
        <div className="block-num">80</div>
        <div className="block-num">&nbsp;</div>
      </div>
      <div style={singleBlocksStyle}>
        <div className="block" style={{ backgroundColor: '#ffffff' }} />
        <div className="block" style={{ backgroundColor: '#ffffcc' }} />
        <div className="block" style={{ backgroundColor: '#ffffcc' }} />
        <div className="block" style={{ backgroundColor: '#a1dab4' }} />
        <div className="block" style={{ backgroundColor: '#a1dab4' }} />
        <div className="block" style={{ backgroundColor: '#41b6c4' }} />
        <div className="block" style={{ backgroundColor: '#41b6c4' }} />
        <div className="block" style={{ backgroundColor: '#2c7fb8' }} />
        <div className="block" style={{ backgroundColor: '#2c7fb8' }} />
        <div className="block" style={{ backgroundColor: '#253494' }} />
        <div className="block" style={{ backgroundColor: '#253494' }} />
      </div>
      <div style={doubleBlocksStyle}>
        <div className="block" style={{ backgroundColor: '#ffffff' }} />
        <div className="block" style={{ backgroundColor: '#ffffcc' }} />
        <div className="block" style={{ backgroundColor: '#ffffcc' }} />
        <div className="block" style={{ backgroundColor: '#c2e699' }} />
        <div className="block" style={{ backgroundColor: '#c2e699' }} />
        <div className="block" style={{ backgroundColor: '#78c679' }} />
        <div className="block" style={{ backgroundColor: '#78c679' }} />
        <div className="block" style={{ backgroundColor: '#31a354' }} />
        <div className="block" style={{ backgroundColor: '#31a354' }} />
        <div className="block" style={{ backgroundColor: '#006837' }} />
        <div className="block" style={{ backgroundColor: '#006837' }} />
      </div>
      <div style={boosterBlocksStyle}>
        <div className="block" style={{ backgroundColor: '#ffffff' }} />
        <div className="block" style={{ backgroundColor: '#ffffb2' }} />
        <div className="block" style={{ backgroundColor: '#ffffb2' }} />
        <div className="block" style={{ backgroundColor: '#fecc5c' }} />
        <div className="block" style={{ backgroundColor: '#fecc5c' }} />
        <div className="block" style={{ backgroundColor: '#fd8d3c' }} />
        <div className="block" style={{ backgroundColor: '#fd8d3c' }} />
        <div className="block" style={{ backgroundColor: '#f03b20' }} />
        <div className="block" style={{ backgroundColor: '#f03b20' }} />
        <div className="block" style={{ backgroundColor: '#bd0026' }} />
        <div className="block" style={{ backgroundColor: '#bd0026' }} />
      </div>
    </div>
  );
}
